import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

export const state = {
  visible: null,
}

export const getters = {
  getVisible: (state) => {
    return state?.visible
  },
}

export const mutations = {
  setVisible(state, { visible }) {
    state.visible = visible
  },
}

export const actions = {
  showError({ commit, getters }, message) {
    // Don't show error if toast is visible
    if (getters.getVisible) return

    commit('setVisible', { visible: true })

    Vue.toasted.show(message, {
      className: 'default-toast',
      fullWidth: true,
      position: 'bottom-center',
      duration: 4000,
      singleton: true,
      onComplete: () => commit('setVisible', { visible: false }),
    })
  },
}
